import { render, staticRenderFns } from "./EditDateInput.vue?vue&type=template&id=58514f83"
import script from "./EditDateInput.vue?vue&type=script&lang=js"
export * from "./EditDateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports